import i18n from '../i18n';

export const API_LANGUAGES = ['ku', 'ar'];

export function getAcceptLanguage(language = i18n.language) {
  const code = (language || 'ku').split('-')[0].toLowerCase();
  return API_LANGUAGES.includes(code) ? code : 'ku';
}
